import {
  faBolt,
  faCrown,
  faGem,
  faHeart,
  faMedal,
  faPlus,
  faStar,
  faTrophy
} from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n, { Ti18nKeys } from "../../../../constants/i18n";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import { TSubscriptionType } from "../../../../Types";

const TagBadge = withLiteObserverAndTheme<{
  tagType: TSubscriptionType;
}>((props) => {
  const { tagType, theme } = props;
  const { colors, unitX } = theme;

  const getTagStyle = (): {
    color: string;
    text: Ti18nKeys;
    icon: IconProp;
  } => {
    switch (tagType) {
      case "VIP":
        return { color: colors.all.vipGold, text: "VIP", icon: faCrown };
      case "ALKHATTABAT":
        return {
          color: colors.all.brightCyan,
          text: "KHATTABAT_TAG",
          icon: faHeart
        };
      case "PLATINUM":
        return {
          color: colors.all.mutedSteelBlue,
          text: "PLATINUM",
          icon: faGem
        };
      case "SILVER":
        return { color: colors.all.plumBrown, text: "SILVER", icon: faMedal };
      case "GOLD":
        return { color: colors.all.bronzedGold, text: "GOLD", icon: faTrophy };
      case "PLUS":
        return { color: colors.all.purple, text: "PLUS", icon: faPlus };
      case "ADVANCED":
        return {
          color: colors.all.mutedSteelBlue,
          text: "ADVANCED_IOS",
          icon: faBolt
        };
      case "BLACK":
        return { color: colors.all.black, text: "BLACK", icon: faStar };
      default:
        return { color: colors.all.darkGray, text: "VIP", icon: faCrown };
    }
  };

  const { color: tagColor, text: tagText, icon: tagIcon } = getTagStyle();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={370}
      height={46}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={tagColor}
      style={{
        borderTopLeftRadius: 16 * unitX,
        borderTopRightRadius: 16 * unitX
      }}
      onClick={() => {}}
    >
      <FontAwesomeIcon
        icon={tagIcon}
        color={colors.all.white}
        style={{ fontSize: 16 * unitX, marginRight: 10 * unitX }}
      />
      <Et3Text
        text={i18n.get(tagText)}
        fontFamily="BOLD"
        fontSize={15}
        color={colors.all.white}
        isSpan={true}
        style={{ letterSpacing: 1.5 }}
      />
    </ET3Div>
  );
});

export default TagBadge;
